import "./_header.scss";

import cx from "classnames";
import {useState} from "react";

function ButtonHamburger({
  onClick = () => {},
}: {
  onClick?: () => void;
}): JSX.Element {
  const [isActive, setIsActive] = useState<boolean>(false);
  const handleClick = (): void => {
    onClick();
    setIsActive(!isActive);
  };
  return (
    <div className={cx("hamburger")} onClick={handleClick}>
      <div
        className={"hamburger-content " + (isActive ? "is-active" : "")}
        id="hamburger-1">
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </div>
    </div>
  );
}

export default ButtonHamburger;
